import axios from 'axios'
import {CADASTRAR_TRECHO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function cadastrarTrecho(empresa) {
    const url = `${URL}/trecho/cadastrar`;
    return dispatch => axios.post(url, empresa, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_TRECHO,
            payload: response
        })
    );
}
